/* eslint-disable @wyz/module/no-relative-import */
import { Icon } from '@wyz/ui';
import { Trans } from '~/common/context';
import { Link, useMatch } from 'react-router';
import './quote-mode-switcher.scss';
import clsx from 'clsx';
import { usePurchaseContext } from '~/purchase/context';
import { PurchaseTracking } from '~/purchase/helpers';

function QuoteModeSwitcher() {
  const { state } = usePurchaseContext();

  const isServiceMode = Boolean(useMatch('/quotes/services/*'));
  const isExpressMode = Boolean(useMatch('/quotes/express/*'));
  const isQuoteMode = !isServiceMode && !isExpressMode;

  return (
    <div className='quote-mode-switcher mt-4'>
      <Link
        id='tab-tyre-search'
        to='/quotes/search'
        className={clsx('quote-mode-tab', {
          'quote-mode-tab--active': isQuoteMode,
        })}
        onClick={() => {
          if (!isQuoteMode)
            PurchaseTracking.trackQuoteSearchTabClicked('MANUAL');
        }}
      >
        <div className='quote-mode-tab__icon'>
          <Icon icon='tyre' />
        </div>
        <div className='quote-mode-tab__content'>
          <div className='quote-mode-tab__title'>
            <Trans i18nKey='app.purchase.quote_search.mode.tyres.title' />
          </div>
          <div className='quote-mode-tab__subtitle'>
            <Trans i18nKey='app.purchase.quote_search.mode.tyres.subtitle' />
          </div>
        </div>
        <div className='quote-mode-tab__chevron'>
          <Icon icon='arrow-down' size='sm' />
        </div>
      </Link>
      {state.targetCustomer?.expressQuoteSearchable && (
        <Link
          id='tab-express-quote'
          to='/quotes/express/search'
          className={clsx('quote-mode-tab', {
            'quote-mode-tab--active': isExpressMode,
          })}
          onClick={() => {
            if (!isExpressMode)
              PurchaseTracking.trackQuoteSearchTabClicked('EXPRESS');
          }}
        >
          <div className='quote-mode-tab__icon'>
            <Icon icon='express-quote' />
          </div>
          <div className='quote-mode-tab__content'>
            <div className='quote-mode-tab__title'>
              <Trans i18nKey='app.purchase.quote_search.mode.express.title' />
            </div>
            <div className='quote-mode-tab__subtitle'>
              <Trans i18nKey='app.purchase.quote_search.mode.express.subtitle' />
            </div>
          </div>
          <div className='quote-mode-tab__chevron'>
            <Icon icon='arrow-down' size='sm' />
          </div>
        </Link>
      )}
      <Link
        id='tab-service-search'
        to='/quotes/services/search'
        className={clsx('quote-mode-tab', {
          'quote-mode-tab--active': isServiceMode,
        })}
        onClick={() => {
          if (!isServiceMode)
            PurchaseTracking.trackQuoteSearchTabClicked('SERVICE');
        }}
      >
        <div className='quote-mode-tab__icon'>
          <Icon icon='quote-service' />
        </div>
        <div className='quote-mode-tab__content'>
          <div className='quote-mode-tab__title'>
            <Trans i18nKey='app.purchase.quote_search.mode.services.title' />
          </div>
          <div className='quote-mode-tab__subtitle'>
            <Trans i18nKey='app.purchase.quote_search.mode.services.subtitle' />
          </div>
        </div>
        <div className='quote-mode-tab__chevron'>
          <Icon icon='arrow-right' size='sm' />
        </div>
      </Link>
    </div>
  );
}

export default QuoteModeSwitcher;
